import { DialogModal } from '@/components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useSolveQuestion } from '@/context/solve-question-context';
import { useMemo } from 'react';

const reportSchema = yup.object({
	reportReason: yup.string().required('Lütfen bir rapor nedeni seçin')
});

type ReportFormData = {
	reportReason: string;
};

export const ReportModal = () => {
	const { isActiveQuestionReport, setIsActiveQuestionReport, setIsDisabledQuestionTimer, allReportReasons, createReportedQuestion, getActiveQuestion } = useSolveQuestion();

	const activeQuestion = useMemo(() => getActiveQuestion(), [getActiveQuestion]);

	const {
		register,
		handleSubmit,
		formState: { errors, isValid },
		reset,
		watch
	} = useForm<ReportFormData>({
		resolver: yupResolver(reportSchema),
		mode: 'onChange'
	});

	const onReportQuestion = async () => {
		if (createReportedQuestion.isLoading) {
			return;
		}

		await createReportedQuestion.mutateAsync({
			questionId: activeQuestion.questionId,
			reportReasonId: watch('reportReason')
		});

		reset();
	};

	const onCloseReportModal = () => {
		setIsActiveQuestionReport(false);
		setIsDisabledQuestionTimer(false);
		reset();
	};

	return (
		<DialogModal
			isOpen={isActiveQuestionReport}
			onClose={onCloseReportModal}
			className="solver-report-dialog-modal"
			variant="danger"
			mobileBottomSheet
			title="Soruyu Raporla"
			primaryButtonText="Raporla"
			secondaryButtonText="Vazgeç"
			primaryButtonActive={isValid}
			onSecondaryClick={onCloseReportModal}
			secondaryButtonActive={!createReportedQuestion.isLoading}
			onPrimaryClick={handleSubmit(onReportQuestion)}
			customXIcon={<i className="icons-x" />}>
			<p>Uygunsuz raporlama yapan uzmanların hesapları kalıcı olarak pasife alınır. Raporlama yaparken buna dikkat ediniz.</p>

			<form className="report-form">
				{allReportReasons?.map((option, index) => (
					<div
						className="report-option"
						key={index}>
						<label className="report-option-label">
							<input
								type="radio"
								value={option?.id}
								{...register('reportReason')}
								className="report-option-input"
							/>
							<span className="report-option-text">{option?.description}</span>
						</label>
					</div>
				))}
				{errors.reportReason && <p className="error-message">{errors.reportReason.message}</p>}
			</form>
		</DialogModal>
	);
};
